import { URL } from "../utils/constants.ts";

const localURL = "https://localhost:5001/api";

export async function addNewOrder(order, token) {
  const url = URL + "/Order/order";

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(order),
  });

  if (!response.ok) {
    const error = new Error("An error occurred while creating order.");
    error.code = response.status;
    try {
      error.info = await response.json();
    } catch (e) {
      error.info = await response.text();
    }
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  return await response.json();
}

export async function addNewAddress(order) {
  const url = URL + "/Order/address";

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
    },
    body: JSON.stringify(order),
  });

  if (!response.ok) {
    const error = new Error("An error occurred while creating address.");
    error.code = response.status;
    try {
      error.info = await response.json();
    } catch (e) {
      error.info = await response.text();
    }
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  return await response.json();
}

export async function updateUserAddress(userId, addressId) {
  const url = URL + `/User/address?idUser=${userId}&idAddress=${addressId}`;

  const response = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const error = new Error(
      "An error occurred while updating the filament weight."
    );
    error.code = response.status;
    try {
      error.info = await response.json(); // Try to get the JSON error response
    } catch (e) {
      error.info = await response.text(); // Fallback to text if JSON is not available
    }
    throw error;
  }

  // Check if the response has content
  if (response.status !== 204 && response.status !== 200) {
    const error = new Error("Unexpected response status.");
    error.code = response.status;
    error.info = await response.text(); // Get raw response text
    throw error;
  }

  // If the response is successful and contains a body, parse it
  try {
    const updatedFilament = await response.json(); // Only call .json() if there is a response body
    return updatedFilament;
  } catch (e) {
    // If there's no JSON body, return a default object or handle as needed
    return null;
  }
}

export async function getOrders() {
  let url = URL + "/Order";

  const response = await fetch(url);

  if (!response.ok) {
    const error = new Error("An error occurred while fetching the categories.");
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  const categories = await response.json();

  return categories;
}

export async function getStatistics() {
  let url = URL + "/Order/statistics";

  const response = await fetch(url);

  if (!response.ok) {
    const error = new Error("An error occurred while fetching the categories.");
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  const categories = await response.json();

  return categories;
}

export async function getOrderDetails(orderId) {
  let url = URL + "/Order/orderdetails/" + orderId;

  const response = await fetch(url);

  if (!response.ok) {
    const error = new Error("An error occurred while fetching the categories.");
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  const categories = await response.json();

  return categories;
}

export async function updateOrderStatus(orderId, status, token) {
  const url = URL + `/Order/${orderId}?status=${status}`;

  const response = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const error = new Error(
      "An error occurred while updating the order status."
    );
    error.code = response.status;
    try {
      error.info = await response.json(); // Try to get the JSON error response
    } catch (e) {
      error.info = await response.text(); // Fallback to text if JSON is not available
    }
    throw error;
  }
}

export async function updateOrderPaymentStatus(orderId, status, token) {
  const url = URL + `/Order/paymentStatus/${orderId}?status=${status}`;

  const response = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const error = new Error(
      "An error occurred while updating the order status."
    );
    error.code = response.status;
    try {
      error.info = await response.json(); // Try to get the JSON error response
    } catch (e) {
      error.info = await response.text(); // Fallback to text if JSON is not available
    }
    throw error;
  }
}

export async function createOrderInvoice(orderId, token) {
  const url = URL + `/Order/invoice/${orderId}`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const error = new Error(
      "An error occurred while updating the order status."
    );
    error.code = response.status;
    try {
      error.info = await response.json(); // Try to get the JSON error response
    } catch (e) {
      error.info = await response.text(); // Fallback to text if JSON is not available
    }
    throw error;
  }
  return await response.json();
}

export async function updateOrderNote(orderId, note, token) {
  const url = URL + `/Order/note/${orderId}?note=${note}`;

  const response = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const error = new Error(
      "An error occurred while updating the order status."
    );
    error.code = response.status;
    try {
      error.info = await response.json(); // Try to get the JSON error response
    } catch (e) {
      error.info = await response.text(); // Fallback to text if JSON is not available
    }
    throw error;
  }
}

export async function sendEmail(email) {
  const url = URL + "/Email/sendEmail";

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
    },
    body: JSON.stringify(email),
  });

  if (!response.ok) {
    const error = new Error("An error occurred while sending email.");
    error.code = response.status;
    try {
      error.info = await response.json();
    } catch (e) {
      error.info = await response.text();
    }
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  return await response.json();
}

export async function getInvoicess() {
  let url = URL + "/Order/invoices";

  const response = await fetch(url);

  if (!response.ok) {
    const error = new Error("An error occurred while fetching the categories.");
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  const categories = await response.json();

  return categories;
}

export async function updateOrderQuantity(orderId, productId, quantity, token) {
  const url =
    URL + `/OrderDetails/quantity/${orderId}/${productId}/${quantity}`;

  const response = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const error = new Error(
      "An error occurred while updating the order status."
    );
    error.code = response.status;
    try {
      error.info = await response.json(); // Try to get the JSON error response
    } catch (e) {
      error.info = await response.text(); // Fallback to text if JSON is not available
    }
    throw error;
  }
}
export async function deleteOrderProduct(orderId, productId, token) {
  const url = `${URL}/OrderDetails/${orderId}/${productId}`;

  const response = await fetch(url, {
    method: "DELETE",
    headers: {
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const error = new Error(
      "An error occurred while deleting the product from the order."
    );
    error.code = response.status;
    try {
      error.info = await response.json(); // Try to get the JSON error response
    } catch (e) {
      error.info = await response.text(); // Fallback to text if JSON is not available
    }
    throw error;
  }
}

export async function createCardPayment(order, token) {
  const url = URL + `/Payment/registerPayment`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(order),
  });

  if (!response.ok) {
    const error = new Error(
      "An error occurred while updating the order payment."
    );
    error.code = response.status;
    try {
      error.info = await response.json(); // Try to get the JSON error response
    } catch (e) {
      error.info = await response.text(); // Fallback to text if JSON is not available
    }
    throw error;
  }
  return await response.json();
}

export async function getPaymentStatus(orderId) {
  let url = URL + "/Payment/status/" + orderId;

  const response = await fetch(url);

  if (!response.ok) {
    const error = new Error("An error occurred while fetching the status.");
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  const categories = await response.json();

  return categories;
}
